export const GRAFTCODE_ONBOARDING_GUIDE_OS = {
  windows: 'Windows',
  macos: 'macOS',
  linux: 'Linux',
} as const

export type GraftcodeOnboardingGuideOs =
  (typeof GRAFTCODE_ONBOARDING_GUIDE_OS)[keyof typeof GRAFTCODE_ONBOARDING_GUIDE_OS]

export const GRAFTCODE_ONBOARDING_GUIDE_OS_OPTIONS: GraftcodeOnboardingGuideOs[] = [
  GRAFTCODE_ONBOARDING_GUIDE_OS.windows,
  GRAFTCODE_ONBOARDING_GUIDE_OS.macos,
  GRAFTCODE_ONBOARDING_GUIDE_OS.linux,
]
